import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useUser } from '@clerk/clerk-react'
import LandingHeader from '../components/LandingHeader'

export default function Home() {
  const { user, isLoaded } = useUser()
  const navigate = useNavigate()
  const [showVision, setShowVision] = useState(false)

  useEffect(() => {
    if (isLoaded && user) {
      navigate('/dashboard')
    }
  }, [user, isLoaded, navigate])

  if (!isLoaded) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-black">
        <div className="text-center space-y-4 animate-pulse">
          <div className="w-12 h-12 mx-auto bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center">
            <span className="text-white font-black text-xs">NP</span>
          </div>
          <p className="text-zinc-500 text-xs font-black uppercase tracking-widest">
            Loading...
          </p>
        </div>
      </div>
    )
  }

  return (
    <main className="relative min-h-screen bg-black text-white selection:bg-white/20 overflow-x-hidden">
      <LandingHeader />
      <section className="pt-24 px-6 pb-16 max-w-6xl mx-auto">
        <div className="border border-white/10 rounded-xl p-8 bg-white/5">
          <h1 className="text-4xl md:text-6xl font-black tracking-tight">Open The Doorz</h1>
          <p className="mt-4 text-zinc-300 max-w-2xl">
            Institutional-grade wallet and lending infrastructure for Starknet.
          </p>
          <div className="mt-8 flex gap-3">
            <button
              onClick={() => setShowVision(true)}
              className="px-5 py-2 bg-white text-black text-sm font-bold rounded hover:bg-zinc-200"
            >
              Vision
            </button>
            <a
              href="/dashboard"
              className="px-5 py-2 border border-white/30 text-white text-sm font-bold rounded hover:border-white"
            >
              Dashboard
            </a>
          </div>
        </div>
      </section>
      
      {/* Vision Deck Modal */}
      {showVision && (
        <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-6">
          <div className="bg-[#0b0b0b] border border-white/20 rounded-xl p-6 max-w-2xl w-full">
            <h2 className="text-2xl font-bold">Product Vision</h2>
            <p className="mt-3 text-zinc-300">
              NeoPawn enables white-label on-chain lending experiences with configurable risk, tenant-aware branding, and automated infrastructure provisioning.
            </p>
            <div className="mt-6 flex justify-end">
              <button
                onClick={() => setShowVision(false)}
                className="px-4 py-2 bg-white text-black text-sm font-bold rounded hover:bg-zinc-200"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </main>
  )
}
